module.exports = __webpack_public_path__ + "img/services-buy-1.67d2c91b.svg";